import { cloneDeep } from 'lodash/lang'

const setWaiverForms = (_state, action) => {
  const { waiverForms } = action

  return cloneDeep(waiverForms)
}

export default setWaiverForms
